import WallDisplayFlashSale2Modal from 'src/components/Modals/WallDisplayFlashSale2Modal.svelte';
import { PROMOTIONS } from 'src/constants';
import { canManageHomeEntities } from 'src/helpers/houses/homes_helpers';
import { home_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const WallDisplayFlashSale2ModalConfig = (forceShow = false) => {
	return {
		id: 'wallDisplayFlashSale2',
		component: WallDisplayFlashSale2Modal,
		props: {
			showModal: true,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					const homeData = get(home_data);
					const hasBeenSeen = !!homeData?.promotions?.wallDisplayFlashSale2;
					const isEligible = !!homeData?.aep?.wdfs2?.code || import.meta.env.DEV;
					// Only surface the campaign on the main unit account, never on a
					// shared/sub account (e.g. when it initially loads a shared home).
					const isMainUnitAccount = canManageHomeEntities();

					return (
						isEligible &&
						isMainUnitAccount &&
						now >= PROMOTIONS.WALL_DISPLAY_FLASH_SALE_2.START_DATE &&
						now < PROMOTIONS.WALL_DISPLAY_FLASH_SALE_2.END_DATE &&
						(!hasBeenSeen || forceShow)
					);
				},
				expected: true,
			},
		],
	};
};
